<template>
	<v-card class="ServerAccountAccount">
		<template v-if="isLoading">
			<div class="text-xs-center pa-5">
				<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
				<div class="caption mt-4">{{loadingText}}</div>
			</div>
		</template>
		<template v-if="!isLoading">
			<v-card-title class="p-0 pl-3">
				<span><b>{{accountDetails.domain}}</b></span>
				<v-spacer></v-spacer>
				<v-btn icon @click="closeMe(false)">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title> 
			<div class="AccountBody">
				<div class="AccountBodyTitle"><span>Bilgileri Güncelle</span></div>
				<div class="text-xs-center">
					<v-btn round color="info" outline :loading="isUpdatingWhm" @click="updateWhm()">WHM Bilgilerini Güncelle</v-btn>  
				</div>
				<div class="text-xs-center"> 
					<v-btn round color="info" outline :loading="isUpdatingNetmin" @click="updateNetmin()">Netmin Bilgilerini Güncelle</v-btn>
				</div> 
			</div>
			<div class="AccountBody">
				<div class="AccountBodyTitle"><span>DNS Bilgileri</span></div>
				<div class="AccountBodyInfos">
					<div class="AccountBodyInfo"> <b>Durum: </b> <span v-if="accountDetails.dns.is_registed" class="text-success">Kayıtlı</span> <span v-if="!accountDetails.dns.is_registed" class="text-error">Düşmüş</span> </div> 
					<div class="AccountBodyInfo"> <b>Kalan Gün:</b> {{accountDetails.dns.balance}} gün kaldı </div> 
					<div class="AccountBodyInfo"> <b>NS1:</b> {{accountDetails.dns.ns1}} </div> 
					<div class="AccountBodyInfo"> <b>NS2:</b> {{accountDetails.dns.ns2}} </div> 
					<div class="AccountBodyInfo"> <b>MX:</b> {{accountDetails.dns.mx}} </div> 
					<div class="AccountBodyInfo"> <b>IP:</b> {{accountDetails.dns.ip}} </div> 
				</div>
			</div>
			<div class="AccountBody">
				<div class="AccountBodyTitle"><span>Subdomainler</span></div>
				<div class="AccountBodyInfos">
					<div class="AccountBodyInfo" v-for="(sdomain,sdomainIndex) in accountDetails.subdomains" :key="'sdomain'+sdomainIndex">
						{{sdomain.domain}}
					</div> 
				</div>
			</div>
			<div class="AccountBody">
				<div class="AccountBodyTitle"><span>Addon Domains</span></div>
				<div class="AccountBodyInfos">
					<div class="AccountBodyInfo" v-for="(adddomain,adddomainIndex) in accountDetails.addondomains" :key="'adddomain'+adddomainIndex">
						{{adddomain.domain}}
					</div> 
				</div>
			</div>
			<div class="AccountBody">
				<div class="AccountBodyTitle"><span>Veritabanları</span></div>
				<div class="AccountBodyInfos">
					<div class="AccountBodyInfo" v-for="(adb,adbIndex) in accountDetails.databases" :key="'adb'+adbIndex">
						{{adb.db}} <small>({{adb.sizemeg}}MB)</small>
					</div> 
				</div>
			</div>
			<div class="AccountBody">
				<div class="AccountBodyTitle"><span>Veritabanı Kullanıcıları</span></div>
				<div class="AccountBodyInfos">
					<div class="AccountBodyInfo" v-for="(adbu,adbuIndex) in accountDetails.databaseusers" :key="'adbu'+adbuIndex">
						{{adbu.user}}
					</div> 
				</div>
			</div>
			<!-- <v-card-actions class="pr-4 pl-4 pb-4">
				<v-btn round outline color="error" dark @click="closeMe(false)">Vazgeç</v-btn>
				<v-spacer></v-spacer>
				<v-btn round disabled v-if="creatableStatus == 'none'">Domain belirle</v-btn>
				<v-btn round color="error" disabled v-if="creatableStatus == 'already'">Bu domain olmaz</v-btn>
				<v-btn round color="primary" dark v-if="creatableStatus == 'canbe'" @click="createAccount()">Oluştur
				</v-btn>
			</v-card-actions> -->
		</template>
	</v-card>
</template>


<script>
	export default {
		name: 'ServerAccountAccount',
		props: ['account'],
		data: () => ({
			isLoading: true,
			isLoading: false,
			loadingText: "",
			accountDetails: {},
			isUpdatingWhm : false,
			isUpdatingNetmin : false,
		}),
		mounted() {
			this.loadingText = "Domain bilgileri yükleniyor"
			this.loadAccount();
			this.isUpdatingWhm = false;
			this.isUpdatingNetmin = false;
		},
		methods: { 
			loadAccount() { 
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/server/domains/detail", {
					params : { domain: this.account.domain  }
				}).then(response => {  
					this.accountDetails = response.body;
					this.isLoading = false; 
				})  
			},
			closeMe(e) {
				this.$emit("closeMe", e)
			},
			updateWhm(){
				this.isUpdatingWhm = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/server/accounts/resetauth", {
					params : { domain: this.account.domain  }
				}).then(response => {  
					this.isUpdatingWhm = false;
				}) 
			},
			updateNetmin(){
				this.isUpdatingNetmin = true;
			},
		},
		computed: {
			getPackages() {
				var packages = [];
				for (var i in this.packages) {
					var p = this.packages[i]
					var name = p.name;
					if (p.BWLIMIT) {
						name += " - ";
						name += parseFloat(p.BWLIMIT / 1000).toFixed(0) + "GB"
					}
					if (p.MAXADDON) {
						name += " - ";
						name += p.MAXADDON + " domain"
					}
					packages.push({
						value: p.name,
						text: name,
					});
				}
				return packages;
			},
			creatableStatus() {
				if (this.domainName == "") {
					return "none"
				}
				var re = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/);
				if (!this.domainName.match(re)) {
					return "none"
				}
				var index = this.accounts.findIndex(item => item.domain == this.domainName);
				if (index > -1) {
					return "already"
				}
				return "canbe"
			}
		}
	}
</script>


<style lang="less">
	.ServerAccountAccount {
		.AccountBody {
			border-top:2px solid #3f51b5;
			padding : 0px 15px 15px 15px;
			// background: red;
			.AccountBodyTitle{
				text-align: center;
				margin-bottom:10px;
				span{
					display: table;
					background-color: #3f51b5;
					color : #fff;
					line-height : 20px;
					font-size:13px;
					margin:0px auto 0px auto;
					padding : 0px 15px;
					border-bottom-left-radius: 10px;
					border-bottom-right-radius: 10px;
				}
			}
			.AccountBodyInfos{
				.AccountBodyInfo{
					padding-left : 5px;
					line-height: 22px;
					&:not(:last-child){
						border-bottom:1px dashed #ccc;
					}
					.text-success{
						color : rgb(0, 131, 0)
					}
					.text-error{
						color : rgb(184, 0, 0)
					}
				}
			}
		}
	}
</style>